import React, { useState, useEffect, ImgHTMLAttributes } from "react";

interface Props extends ImgHTMLAttributes<HTMLImageElement> {
  name: string;
}

const SVGAsset: React.FC<Props> = ({ name, ...props }) => {
  const [SvgComponent, setSvgComponent] = useState<string | null>(null);
  const [isLoading, setIsLoading] = useState(true);
  const [hasError, setHasError] = useState(false);

  useEffect(() => {
    setIsLoading(true);
    setHasError(false);
    setSvgComponent(null);

    if (!name || name.trim() === "") {
      console.error("SVGAsset: Invalid or empty name prop provided:", name);
      setHasError(true);
      setIsLoading(false);
      return;
    }

    const sanitizedName = name.trim();

    const loadSvg = async () => {
      try {
        const Svg = await import(`@/assets/svg/${sanitizedName}.svg?url`);
        setSvgComponent(Svg.default);
        setIsLoading(false);
      } catch (error) {
        console.error(`Failed to load SVG: ${sanitizedName}`, error);
        setHasError(true);
        setIsLoading(false);
      }
    };

    loadSvg().then();
  }, [name]);

  if (isLoading) {
    return <span></span>;
  }

  if (hasError || !SvgComponent) {
    return <span title={`Failed to load SVG: ${name}`}></span>;
  }

  return <img src={SvgComponent} alt={`${name} icon`} {...props} />;
};

export default SVGAsset;
